var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',{staticClass:"text-2xl text-center"},[_vm._v(_vm._s(_vm.titleJa))]),_vm._v(" "),_c('h3',{staticClass:"mt-4 text-orange text-center"},[_vm._v(_vm._s(_vm.titleEn))])])}
var staticRenderFns = []

export { render, staticRenderFns }